import { render } from "./AdicionarTimesModal.vue?vue&type=template&id=687ef396&scoped=true"
import script from "./AdicionarTimesModal.vue?vue&type=script&lang=js"
export * from "./AdicionarTimesModal.vue?vue&type=script&lang=js"

import "./AdicionarTimesModal.vue?vue&type=style&index=0&id=687ef396&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687ef396"]])

export default __exports__